import React from "react";

export const About = (props) => {
  const renderParagraphs = () => {
    if (!props.data) return <p className="paragraph">loading...</p>;

    const paragraphs = [];
    for (let i = 0; i <= 10; i++) {
      const key = i === 0 ? "paragraph" : `paragraph${i}`;
      if (props.data[key]) {
        paragraphs.push(
          <p className="paragraph" key={key}>
            {props.data[key]}
          </p>
        );
      }
    }
    return paragraphs;
  };

  return (
    <div id="about">
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>
                Conheça a{" "}
                {props.data ? props.data.NameBank : "Banco indefinido"}{" PRIME VITTA "}
                Experience
              </h2>

              {/* Parágrafos renderizados dinamicamente */}
              {renderParagraphs()}

              <h3>Porque nos escolher? Por que Somos!</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 d-flex">
            <img src="img/bout.png" className="img-responsive" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};